// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federungssysteme/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federungssystemeDE: PageEntry = {
  id: "post.federungssysteme",
  locale: "de",
  slug: "federungssysteme",
  seo: {
    title: "Glossar: Federungssysteme einfach erklärt | Dietz GmbH",
    description: "Federungssysteme sind Mechanismen, die Federn verwenden, um Stöße und Vibrationen in Fahrzeugen oder anderen mechanischen Systemen zu absorbieren. In Fahrzeugen dienen Federungssys",
  },
  type: "post",
  h1: "Glossar: Federungssysteme einfach erklärt",
  intro: "Federungssysteme sind Mechanismen, die Federn verwenden, um Stöße und Vibrationen in Fahrzeugen oder anderen mechanischen Systemen zu absorbieren. In Fahrzeugen dienen Federungssysteme dazu, Unebenheiten der Straße auszugleichen und den Fahrkomfort zu verbessern. Diese Systeme umfassen oft Stoßdämpfer in Kombination mit verschiedenen Federtypen. Die Auslegung von effektiven Federungssystemen erfordert ein genaues Verständnis der dynamischen Eigenschaften von Federn sowie der spezifischen Anforderungen der Anwendung.",
  blocks: [

  ],
};
